/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';
import { getIconForMcpServer } from './constants/mcp-templates';

export default class McpServer extends Model {
  @attr('string') declare name: string;
  @attr('string') declare url: string;
  @attr('string') declare description: string;
  @attr('string') declare token_id: string;
  @attr('string') declare auth_type: string;

  get icon(): string {
    return getIconForMcpServer(this.name);
  }
}
